import { render, staticRenderFns } from "./confirm-copy.vue?vue&type=template&id=5d2c204c"
import script from "./confirm-copy.vue?vue&type=script&lang=js"
export * from "./confirm-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports